import React, { useEffect, useState } from "react";

import { CardBase } from "~/components/timeLine/cardBase.jsx";
import { RegistrationListTemplate } from "../../dayTemplate/registrationListTemplate.jsx";
import { $t } from "~/i18n.js";
import { HelpLine } from "~/components/help/helpLine.jsx";

export const CardLists = ({ data, saveAndNext, prev }) => {
  const [lists, setLists] = useState([]);
  useEffect(() => {
    setLists(data.registration_lists);
  }, [data.registration_lists, setLists]);

  const handleSave = () => {
    saveAndNext({ registration_lists: lists.filter((l) => !l.delete) });
  };

  return (
    <CardBase prev={prev} next={handleSave}>
      <RegistrationListTemplate value={lists} onChange={setLists} />

      {data.registration_lists.length > 0 && (
        <p className="small" style={{marginTop: 12}}>
          {$t(
            "Overzichtslijsten worden aangemaakt bij het activeren van het rooster."
          )}
        </p>
      )}
    </CardBase>
  );
};
